import posthog from 'posthog-js';
import { getConsent } from './consent';

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  // EU-friendly default: no analytics until the visitor explicitly accepts.
  // The CookieBanner re-calls initAnalytics() the moment they do.
  if (getConsent() !== 'accepted') return;
  const key = import.meta.env.VITE_POSTHOG_KEY;
  const host = import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com';
  if (!key) {
    console.warn('[analytics] VITE_POSTHOG_KEY not set — PostHog disabled');
    return;
  }
  const uiHost = import.meta.env.VITE_POSTHOG_UI_HOST ?? 'https://eu.posthog.com';
  posthog.init(key, {
    api_host: host,
    ui_host: uiHost,
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: 'identified_only',
    loaded: (ph) => {
      console.log('[analytics] PostHog loaded, distinct_id=', ph.get_distinct_id());
    },
  });
  initialized = true;
  console.log('[analytics] PostHog init called, host=', host);
}

export function capturePageview(path: string) {
  if (!initialized) return;
  posthog.capture('$pageview', { $current_url: window.location.origin + path });
}

export function identifyUser(id: string, props?: Record<string, unknown>) {
  if (!initialized) return;
  posthog.identify(id, props);
}

export function resetAnalytics() {
  if (!initialized) return;
  posthog.reset();
}

export function capture(event: string, props?: Record<string, unknown>) {
  if (!initialized) return;
  posthog.capture(event, props);
}
